import { createAsyncThunk } from '@reduxjs/toolkit';

import logout from 'services/auth/logout';

export const signOutAction = createAsyncThunk('auth/signOut', async () => {
  await logout();
});
